import React from 'react'
const MenuHomeSvg =()=>{
return (<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 21.283 20.955" enableBackground="new 0 0 21.283 20.955" xmlSpace="preserve" width="22px" height="22px"> <path id="path-133" fill="#6889be" d="M13.16,20.952v-5.684h-5v5.684H2.667v-9.9H0L10.877,0l10.406,11.055H18.67v9.9L13.16,20.952z"></path> </svg>)
}
export default MenuHomeSvg;

